import { useSnapshot } from 'valtio';
import { browserState } from './state';

function useBrowserState() {
  const state = useSnapshot(browserState);
  return state;
}

export default useBrowserState;
